module.exports = __webpack_public_path__ + "img/mm-logo.7915373f.svg";